import H5Text from './H5Text';

export default H5Text;
